/**
 * Paths of the data entry lists.
 */

/**
 * Tenant-relative path of the data entry visits list.
 */
export const DATA_ENTRY_VISITS_LIST_PATH = '/data-entry/data-entry-visits';

/**
 * Build the tenant-relative path of the data entry visits list, filtered to one trial.
 *
 * @param trialId - Id of the trial the path filters by.
 * @param trialName - Label of the trial filter; left out when empty.
 * @returns The path, without the `/t/<tenant slug>` prefix.
 */
export const buildDataEntryVisitsListPath = (
  trialId: string | number,
  trialName?: string | null
): string => {
  const queryParams = new URLSearchParams({ trial_id: trialId.toString() });
  if (trialName) {
    queryParams.set('trial_name', trialName);
  }
  return `${DATA_ENTRY_VISITS_LIST_PATH}?${queryParams.toString()}`;
};

/**
 * Trial, scheduled visit, visit and site of an input applications page path.
 */
export interface InputMixApplicationsPathParams {
  trialId: string | number;
  trialName?: string | null;
  scheduledVisitId: string | number;
  visitId: string;
  siteId: string;
}

/**
 * Build the tenant-relative path of the input applications page of one visit.
 *
 * @param params - Visit to open; an empty trial name is left out of the path.
 * @returns The path, without the `/t/<tenant slug>` prefix.
 */
export const buildInputMixApplicationsPath = ({
  trialId,
  trialName,
  scheduledVisitId,
  visitId,
  siteId,
}: InputMixApplicationsPathParams): string => {
  const queryParams = new URLSearchParams({
    visit_id: visitId,
    sv_id: scheduledVisitId.toString(),
    site_id: siteId,
    trial_id: trialId.toString(),
  });
  if (trialName) {
    queryParams.set('trial_name', trialName);
  }
  return `/data-entry/input-mix-applications?${queryParams.toString()}`;
};
